import React from "react";
import "../../account/Account.css"
import Popup from 'reactjs-popup';
import Colors from "../Colors";
import ButtonLoader from "./ButtonLoader";
import Aux from "../AuxFunctions";
import ErrorMessage from "../ErrorPages/ErrorMessage";
import PlusIcon from "mdi-react/PlusIcon";
import MinusIcon from "mdi-react/MinusIcon";
import Fire from "../../config/Fire";
import { withMyDataContext } from "../../context/DataProvider";
import SucessMessage from "../ErrorPages/SucessMessage";
import CloseIcon from "mdi-react/CloseCircleOutlineIcon";
import NumberFormat from "react-number-format";
import { withRouter } from "react-router-dom";

class SendRequestModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            user: {},
            text: "",
            coins: 0,
            errorMessage: "",
            loading: false,
            loadingNormalRequest: false,
            loadingMessage: false,
            sucess: false,
            currentTab: 0,
        }
    }

    handleIncrementCoin = (number) => {
        if (this.state.coins + number >= this.props.myDataProvider.coins) {
            this.setState({ coins: this.props.myDataProvider.coins })
        } else if (!this.state.coins && this.props.myDataProvider.coins > 0) {
            this.setState({ coins: number })
        } else if (!this.state.coins) {
            this.setState({ coins: 0 })
        } else {
            this.setState(prevState => ({ coins: prevState.coins + number }));
            //this.slider.setNativeProps({value: this.state.coins +1});
        }
    }

    handleDecrementCoin = () => {
        if (!this.state.coins || this.state.coins < 0) {
            this.setState({ coins: 0 })
        } else {
            this.setState(prevState => ({ coins: prevState.coins - 1 }));
            //this.slider.setNativeProps({value: this.state.coins -1 });
        }
    }

    handleCoinsSlider = (event) => {
        let num = parseInt(event.target.value, 10)
        this.setState({ coins: num });
    }

    goToAddCoins = () => {
        try {
            this.props.history.push("/account/balance")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    sendSimpleRequest = async () => {
        try {
            if (this.state.loadingNormalRequest)
                return
            if (this.state.user) {
                this.setState({ loadingNormalRequest: true })
                const sent = await Fire.shared.createNotificationRequest(this.props.user.uid, false)
                if (sent === 1) {
                    this.setState({ sucess: true })
                } else if (sent === 2) {
                    this.setState({ error: "You've already sent them a request!" })
                } else {
                    this.setState({ error: "an unexpected error has occurred" })
                }
                this.setState({ loadingNormalRequest: false })
            }

        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingNormalRequest: false })
        }
    }

    onSendMessage = async () => {
        if (this.state.loadingMessage)
            return
        try {
            if (!this.state.text || this.state.text.trim() === "") {
                this.setState({ errorMessage: "Cant be empty" })
                return;
            }

            if (this.state.coins < 1) {
                this.setState({ errorMessage: "minimum amount to send is 1$" })
            } else {
                this.setState({ loadingMessage: true })
                const sent = await Fire.shared.createNotificationRequest(this.props.user.uid, true, this.state.text, this.state.coins)
                if (sent === 1) {
                    this.setState({ sucess: true })
                } else if (sent === 2) {
                    this.setState({ error: "You've already sent them a request!" })
                } else {
                    this.setState({ error: "an unexpected error has occurred" })
                }
                this.setState({ loadingMessage: false })
            }
        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingMessage: false, errorMessage: "an unexpected error has occurred" })
        }
    }

    simpleRequestTab = () => {
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems:"center" }}>
                    <div style={{margin:"20px 0"}}>
                        {Aux.showAvatar(50, this.props.user.avatar, this.props.user.username || "Unknown")}
                    </div>
                    <span style={{ color: Colors.middleText }}>Do you want to chat with?</span>
                    <div style={{ display: "flex", alignSelf: "center", marginTop: 5, alignItems: "center" }}>
                        
                        <span style={{ fontWeight: "bold", fontSize: 19, color: Colors.darkText,  }}>{this.props.user.username}</span>
                    </div>
                </div>

                <ButtonLoader
                    text="Send Request"
                    style={{ backgroundColor: Colors.mainColor, marginTop: 30, width: 250 }}
                    onClick={this.sendSimpleRequest}
                    loading={this.state.loadingNormalRequest}
                >
                </ButtonLoader>
                <div style={{ marginTop: 20 }}>
                    <span style={{ color: "#ccc" }}>Or</span>
                </div>
                {this.state.currentTab === 0 ?
                    <ButtonLoader
                        text="Send a Message"
                        style={{ backgroundColor: Colors.mainColor, marginTop: 20, width: 250 }}
                        onClick={() => this.setState({ currentTab: 1 })}
                        loading={this.state.loadingMessage}
                    ></ButtonLoader> : null}
            </div>)
    }

    renderSendMessage = () => {
        return (
            <div style={{ display: "flex", marginTop: 20, justifyContent: "space-around", flexDirection: "column", width: 350 }}>
                {/* <div style={{ backgroundColor: "#fbfbfb" }}>
                    <div style={{ display: "flex", margin: "20px 10px", alignItems: "center", justifyContent: "space-between" }}>
                        <span style={{ marginRight: 30, marginLeft: 10, fontWeight: "bold", fontSize: 19, color: Colors.darkText }}>
                            to:
                        </span>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {Aux.showAvatar(35, this.props.user.avatar, this.props.user.username || "Unknown")}
                            <h3 style={{ marginRight: 30, marginLeft: 10, fontWeight: "300", fontSize: 14, color: Colors.middleText, overflowWrap: "anywhere" }}>
                                {this.props.user.username || ""}
                            </h3>
                        </div>
                    </div>
                </div> */}
                <div style={{ marginTop: 20 }}>
                    <ErrorMessage text={this.state.errorMessage}></ErrorMessage>
                    <textarea className="login-input" type="text" name="text" rows="4" placeholder="Write something..."
                        style={{ resize: "none", height: "100%", padding: 10 }}
                        onChange={(e) => {
                            this.setState({ text: e.target.value });
                        }}>
                    </textarea>
                </div>

                <div style={{ borderBottomWidth: 1, borderRadius: 15, borderColor: "#eee", borderStyle: "solid", margin: "15px 0" }} />

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span>Available Balance</span>
                    <div onClick={this.goToAddCoins} style={{ display: "flex", alignItems: "center" }}>
                        <h3>${this.props.myDataProvider.coins}</h3>
                        <PlusIcon className="coins-icon" style={{ backgroundColor: Colors.mainColor, color: "white", marginLeft: 10, padding: 2 }}></PlusIcon>
                    </div>
                </div>

                <div style={{ borderBottomWidth: 1, borderRadius: 15, borderColor: "#eee", borderStyle: "solid", margin: "15px 0" }} />
                {this.props.myDataProvider.coins <= 0 ? (
                    <div style={{ justifyContent: "center", alignItems: "center", marginTop: 30 }}>
                        <span>You need to add some balance to continue.</span>
                    </div>
                ) : (
                        <div>
                            <div >
                                <span style={{ display: "flex", alignSelf: "flex-start", margin: "20px 0" }}>Enter Amount</span>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "5px 0" }}>

                                    <div onClick={this.handleDecrementCoin}>
                                        <MinusIcon className="coins-icon" ></MinusIcon>
                                    </div>
                                    <NumberFormat
                                        placeholder="0,00"
                                        className="add-coins-input"
                                        value={this.state.coins}
                                        thousandSeparator={true} prefix={'$'}
                                        allowNegative={false}
                                        decimalScale={0}
                                        onValueChange={(values) => {
                                            const { floatValue } = values;
                                            var myValue = floatValue
                                            var currentCoins = this.props.myDataProvider.user?.coins || 0
                                            if (floatValue > currentCoins) {
                                                myValue = currentCoins
                                            }
                                            this.setState({ coins: myValue })
                                        }} />
                                    {/* <h3>${this.state.coins}</h3> */}
                                    <div onClick={() => this.handleIncrementCoin(1)}>
                                        <PlusIcon className="coins-icon" ></PlusIcon>
                                    </div>

                                </div>
                            </div>
                            <div className="slidecontainer" style={{ marginTop: 10 }}>
                                <input type="range"
                                    // defaultValue={0} 
                                    min={0}
                                    max={this.props.myDataProvider.coins}
                                    step={1}
                                    value={this.state.coins}
                                    className="slider"
                                    onChange={this.handleCoinsSlider}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <span className="coins-add-value" onClick={() => this.handleIncrementCoin(5)}>+5$</span>
                                <span className="coins-add-value" onClick={() => this.handleIncrementCoin(25)}>+25$</span>
                                <span className="coins-add-value" onClick={() => this.handleIncrementCoin(50)}>+50$</span>
                            </div>
                        </div>)}
                <ButtonLoader
                    text="Send Message"
                    style={{ backgroundColor: Colors.mainColor, marginTop: 20 }}
                    onClick={this.onSendMessage}
                    loading={this.state.loading}
                >
                </ButtonLoader>
            </div>

        )
    }
    render() {
        return (
            <Popup
                contentStyle={{ width: "auto", borderRadius: 10, margin: "auto", overflowY: "auto", backgroundColor: "transparent", height: "100%" }}
                open={this.props.active}
                onClose={this.props.onClose}
                closeOnDocumentClick
                modal
            >
                {close => (
                    <div className="container" style={{ display: "flex", maxWidth: 400, flexDirection: "column", padding: 40, margin: "20px 0" }} >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {/* {this.state.currentTab === 0 ?  */}
                            <div style={{ marginRight: 20 }}>
                                <h2>Send Message</h2>
                            </div>
                            {/* :<div className="reversed-button-hover" style={{ display: "flex", alignItems: "center" }}
                                onClick={() => this.setState({ currentTab: 0 })}>
                                <ChevronLeftIcon style={{ marginRight: 5 }}></ChevronLeftIcon>
                                <h2>Send Message</h2>
                            </div> */}
                            <CloseIcon className={"button-hover"} size={30} onClick={close} style={{ float: "right" }}></CloseIcon>
                        </div>

                        {this.state.sucess ?
                            <SucessMessage isSucess={this.state.sucess} text="You've successfully sent a request"></SucessMessage>
                            
                            :
                            <div>
                                <ErrorMessage text={this.state.error}></ErrorMessage>
                                <this.simpleRequestTab></this.simpleRequestTab>
                                {this.state.currentTab !== 0 ? <this.renderSendMessage></this.renderSendMessage> : null}
                            </div>
                        }
                    </div>)}
            </Popup>
        );
    }
}

export default withMyDataContext(withRouter(SendRequestModal))